export default __webpack_public_path__ + "static/media/spotify.8735346e.svg";